import API from 'app/api';
import parseResponse from 'app/api/requests/parsers/response';
import { Series } from 'app/api/entities/series';

const fetchSeries = () =>
  API.Content.getBrowse({
    type: 'series',
    is_simulcast: true,
    n: 10,
    start: 0,
    sort_by: 'popularity',
  })
    .then(parseResponse)
    .then(Series);

export { fetchSeries };
